import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { clients } from "@/mocks/home";

export default function Clients() {
  const [activeId, setActiveId] = useState(clients[0].id);
  const active = clients.find((c) => c.id === activeId) ?? clients[0];

  return (
    <section id="clients" className="scroll-mt-section bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="客户端"
            title="四个入口，同一个账号"
            subtitle="不同设备对应不同客户端，按场景选择即可。它们共用同一账号体系，收藏与观看进度保持同步。"
          />
        </Reveal>

        <Reveal delay={80}>
          <div
            role="tablist"
            aria-label="客户端选择"
            className="mt-8 inline-flex flex-wrap gap-1 rounded-full bg-background-200 p-1"
          >
            {clients.map((client) => (
              <button
                key={client.id}
                role="tab"
                type="button"
                aria-selected={client.id === activeId}
                onClick={() => setActiveId(client.id)}
                className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                  client.id === activeId
                    ? "bg-background-50 text-primary-700"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                <i className={`${client.icon} text-base`} />
                <span className="hidden sm:inline">{client.name}</span>
                <span className="sm:hidden">{client.name.split(" ")[0]}</span>
              </button>
            ))}
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10 items-center rounded-lg bg-background-50 border border-background-200 p-4 md:p-8">
            <div className="w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
              <img
                key={active.id}
                src={active.image}
                alt={`${active.name} 界面示意`}
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div>
              <div className="flex items-center gap-3">
                <span className="w-11 h-11 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center text-2xl">
                  <i className={active.icon} />
                </span>
                <div>
                  <h3 className="font-heading text-xl font-bold text-foreground-950">
                    {active.name}
                  </h3>
                  <p className="text-xs md:text-sm text-accent-700">{active.tagline}</p>
                </div>
              </div>

              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                {active.desc}
              </p>

              <ul className="mt-5 space-y-2.5">
                {active.points.map((point) => (
                  <li key={point} className="flex gap-2.5 text-sm text-foreground-700 leading-relaxed">
                    <i className="ri-arrow-right-s-line text-primary-500 text-lg shrink-0" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}